module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', [_c('cp-nav')], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Painel de Controlo")])]), _vm._v(" "), _c('p', [_vm._v("Painel de administração da prova...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d1b2f55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cp/Painel.vue
// module id = 265
// module chunks = 1